import { Skeleton } from "@mui/material";
import { ScoreArc } from "../../ScoreArc/ScoreArc";
import "./ReportCustomQuestionChapterScores.scss";

interface ReportCustomQuestionChapterScoresProps {
  chapterScores: Array<{ id: string; name: string; score: number }>;
  isLoading: boolean;
}

export const ReportCustomQuestionChapterScores = ({
  chapterScores,
  isLoading,
}: ReportCustomQuestionChapterScoresProps) => {
  if (isLoading) {
    return (
      <div className="ReportCustomQuestionChapterScores">
        <Skeleton variant="circular" width={80} height={80} />
        <Skeleton variant="circular" width={80} height={80} />
        <Skeleton variant="circular" width={80} height={80} />
      </div>
    );
  }

  return (
    <div className="ReportCustomQuestionChapterScores">
      {chapterScores.map((chapter) => (
        <ScoreArc
          key={chapter.id}
          score={chapter.score}
          label={chapter.name}
          size="xSmall"
        />
      ))}
    </div>
  );
};
